import { permanentFeatureFlagDefaults } from '@cosuno/feature-flags';
import { type FC, type PropsWithChildren, useMemo, useState } from 'react';

import type { CompanyFeatureFlags, UserFeatureFlags } from '../types';
import { ExperimentFlagsContext } from './ExperimentFlagsContext';
import { FeatureFlagsContext } from './FeatureFlagsContext';

const defaultValue = permanentFeatureFlagDefaults;

export const RootContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [companyFeatureFlags, setCompanyFeatureFlags] = useState<CompanyFeatureFlags | null>(null);
  const [userFeatureFlags, setUserFeatureFlags] = useState<UserFeatureFlags | null>(null);

  const contextValue = useMemo(
    () => ({
      userFeatureFlags,
      companyFeatureFlags: companyFeatureFlags ?? defaultValue,
      setUserFeatureFlags,
      setCompanyFeatureFlags,
    }),
    [userFeatureFlags, companyFeatureFlags],
  );

  return (
    <ExperimentFlagsContext.Provider value={userFeatureFlags}>
      <FeatureFlagsContext.Provider value={contextValue}>{children}</FeatureFlagsContext.Provider>
    </ExperimentFlagsContext.Provider>
  );
};
